export const REQUEST_LIVE_FEED_FETCH_EM = "REQUEST_LIVE_FEED_FETCH_EM"
export const FETCH_LIVE_FEED_EM_SUCCESS = "FETCH_LIVE_FEED_EM_SUCCESS"
export const FETCH_LIVE_FEED_EM_FAILURE = "FETCH_LIVE_FEED_EM_FAILURE"

export const CLEAR_FETCH_LIVE_FEED_EM_STATES = "CLEAR_FETCH_LIVE_FEED_EM_STATES"